import { combineReducers } from "redux";
import loginReducer from "./login/loginReducer";
import resetPasswordReducer from "./resetPassword/resetPasswordReducer";
import resetPassword2Reducer from "./resetPassword2/resetPassword2Reducer";
//import mnTableReducer from "./mnTable/mnTableReducer";
const rootReducer = combineReducers({
  login: loginReducer,
  resetPassword: resetPasswordReducer,
  resetPassword2: resetPassword2Reducer
  // mnTable: mnTableReducer
});

export default rootReducer;
